import { useQueryClient } from '@tanstack/react-query';
import { useLocation, useNavigate } from '@tanstack/react-router';

import { queries } from '../../../../common/api/queryKeys/queries';

export const useNavigateToOfferEdit = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const location = useLocation();

    return (offerId: string) => {
        navigate({
            to: '/offer/$id/edit',
            params: { id: offerId },
            state: { originLocation: location },
        });

        queryClient.removeQueries({ queryKey: queries.offers.detail(offerId).queryKey });
    };
};
